  <template>
    <div>
        <ul class="web-nav-li">
            <li v-for="(item,index) in headerArray" :key="index">
                <a href="#" v-if="item.children">{{ item.title }}</a>
                <a :href="item.link" v-else>{{ item.title }}</a>
                <ul v-if="item.children">
                    <li v-for="(item_one,index_one) in item.children" :key="index_one"><a :href="item_one.link">{{ item_one.title }}</a></li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "page_header",
    data() {
        return {
            headerArray: []
        };
    },
    methods: {
        getHeader() {
            this.$api.get('/api/web/header-tree/').then((response) => {
                this.headerArray = response.data;
                console.log('this.headerArray',this.headerArray);
            })
        }
    },
    mounted() {
        this.getHeader()
    },
}
</script>